<template>
  <div id="app" :class="{ showTabbar: $route.meta.showTabbar }">
    <keep-alive>
      <router-view
        class="app-sub-page"
        v-if="$route.meta.keepAlive"
      ></router-view>
    </keep-alive>
    <router-view
      class="app-sub-page"
      v-if="!$route.meta.keepAlive"
    ></router-view>
    <div class="page-tabbar van-hairline--top" v-if="$route.meta.showTabbar">
      <app-tabbar></app-tabbar>
    </div>
    <water-mask
      :text="watertext"
      :mobile="watermobile"
      v-if="waterFlag"
    ></water-mask>
  </div>
</template>

<script>
import appTabbar from '@/components/app-tabbar';
import { getUrlParams } from 'common/js/mUtils';
import Watermark from 'common/js/watermark';
import WaterMask from './pages/cooperation-packge/components/water-mask';
export default {
  name: 'App',
  components: {
    appTabbar
  },
  data() {
    return {
      transitionName: 'slide-right',
      watertext: '',
      watermobile: '',
      waterFlag: false
    };
  },
  components: {
    WaterMask
  },
  mounted() {
    let {
      reportAuth = false,
      payAuth = false,
      visaAuth = false,
      accountsAuth = false
    } = getUrlParams();
    this.$store.commit('UPDATE_REPORT_AUTH', reportAuth);
    this.$store.commit('UPDATE_PAY_AUTH', payAuth);
    this.$store.commit('UPDATE_VISA_AUTH', visaAuth);
    this.$store.commit('UPDATE_ACCOUNTS_AUTH', accountsAuth);

    // if (this.watermarkText) {
    //   this.$nextTick(() => {
    //     Watermark.set(this.watermarkText, this.$refs.directrecordwp)
    //   })
    // }
  },
  computed: {
    watermarkText() {
      let { employeeName, mobile } = getUrlParams();
      return decodeURIComponent(employeeName) + '-' + mobile;
    }
  },
  watch: {
    $route(to, from) {
      let isBack = this.$store.state.routeIsBack; // 监听路由变化时的状态为前进还是后退;
      let { name } = to;
      let { employeeName, mobile } = getUrlParams();

      let arry = [
        'cooperationContract',
        'cooperationVisa',
        'cooperationReport',
        'cooperationPay',
        'cooperationAccounts',
        'contractAgreement',
        'cooperationDetail',
        'cooperationAgreementDetail'
      ];
      if (arry.includes(name)) {
        this.waterFlag = true;
        this.watertext = decodeURIComponent(employeeName);
        this.watermobile = mobile;
        Watermark.set(this.watermarkText, this.$refs.directrecordwp);
      } else {
        this.waterFlag = false;
        Watermark.set('', this.$refs.directrecordwp);
      }
      // if (isBack) {
      //   this.transitionName = 'pop-out'
      // } else {
      //   this.transitionName = 'pop-in'
      // }
      // this.$store.commit('UPDATE_ROUTER_IS_BACK')
    },
    watermarkText() {
      Watermark.set(this.watermarkText, this.$refs.directrecordwp);
    }
  },
  created() {
    this.$store.commit('UPDATE_USER_FROM_LOCAL');
  }
};
</script>

<style lang="scss">
#app {
  position: relative;
  height: 100%;
  &.showTabbar {
    padding-bottom: 100px;
  }
  .app-sub-page {
    // height: 100%;
  }
}

//style
//style
.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transition: all 0.2s;
  -webkit-transform: translate(100px, 0);
  transform: translate(100px, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transition: all 0.2s;
  -webkit-transform: translate(-100px, 0);
  transform: translate(-100px, 0);
}

.pop-out-enter-active,
.pop-out-leave-active,
.pop-in-enter-active,
.pop-in-leave-active {
  will-change: transform;
  transition: all 250ms;
  height: 100%;
  width: 100%;
  top: 0;
  position: absolute;
  backface-visibility: hidden;
}

.pop-out-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

.pop-out-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.pop-in-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.pop-in-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

/*!
 * Quill Editor v1.3.4
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
.ql-container {
  box-sizing: border-box;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 13px;
  height: 100%;
  margin: 0px;
  position: relative;
}
.ql-container.ql-disabled .ql-tooltip {
  visibility: hidden;
}
.ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {
  pointer-events: none;
}
.ql-clipboard {
  left: -100000px;
  height: 1px;
  overflow-y: hidden;
  position: absolute;
  top: 50%;
}
.ql-clipboard p {
  margin: 0;
  padding: 0;
}
.ql-editor {
  box-sizing: border-box;
  line-height: 1.42;
  height: 100%;
  outline: none;
  overflow-y: auto;
  padding: 12px 15px;
  tab-size: 4;
  -moz-tab-size: 4;
  text-align: left;
  white-space: pre-wrap;
  word-wrap: break-word;
}
.ql-editor > * {
  cursor: text;
}
.ql-editor p,
.ql-editor ol,
.ql-editor ul,
.ql-editor pre,
.ql-editor blockquote,
.ql-editor h1,
.ql-editor h2,
.ql-editor h3,
.ql-editor h4,
.ql-editor h5,
.ql-editor h6 {
  margin: 0;
  padding: 0;
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor ol,
.ql-editor ul {
  padding-left: 1.5em;
}
.ql-editor ol > li,
.ql-editor ul > li {
  list-style-type: none;
}
.ql-editor ul > li::before {
  content: '\2022';
}
.ql-editor ul[data-checked='true'],
.ql-editor ul[data-checked='false'] {
  pointer-events: none;
}
.ql-editor ul[data-checked='true'] > li *,
.ql-editor ul[data-checked='false'] > li * {
  pointer-events: all;
}
.ql-editor ul[data-checked='true'] > li::before,
.ql-editor ul[data-checked='false'] > li::before {
  color: #777;
  cursor: pointer;
  pointer-events: all;
}
.ql-editor ul[data-checked='true'] > li::before {
  content: '\2611';
}
.ql-editor ul[data-checked='false'] > li::before {
  content: '\2610';
}
.ql-editor li::before {
  display: inline-block;
  white-space: nowrap;
  width: 1.2em;
}
.ql-editor li:not(.ql-direction-rtl)::before {
  margin-left: -1.5em;
  margin-right: 0.3em;
  text-align: right;
}
.ql-editor li.ql-direction-rtl::before {
  margin-left: 0.3em;
  margin-right: -1.5em;
}
.ql-editor ol li:not(.ql-direction-rtl),
.ql-editor ul li:not(.ql-direction-rtl) {
  padding-left: 1.5em;
}
.ql-editor ol li.ql-direction-rtl,
.ql-editor ul li.ql-direction-rtl {
  padding-right: 1.5em;
}
.ql-editor ol li {
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  counter-increment: list-0;
}
.ql-editor ol li:before {
  content: counter(list-0, decimal) '. ';
}
.ql-editor ol li.ql-indent-1 {
  counter-increment: list-1;
}
.ql-editor ol li.ql-indent-1:before {
  content: counter(list-1, lower-alpha) '. ';
}
.ql-editor ol li.ql-indent-1 {
  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor ol li.ql-indent-2 {
  counter-increment: list-2;
}
.ql-editor ol li.ql-indent-2:before {
  content: counter(list-2, lower-roman) '. ';
}
.ql-editor ol li.ql-indent-2 {
  counter-reset: list-3;
}
</style>
